import addressToString from 'utils/address';
import { listToString } from 'utils/normalizers';

const columnsPrediosOaxaca = [
  {
    titleText: 'Clave',
    dataIndex: 'clave',
    key: 'clave',
    width: 200,
  },
  {
    titleText: 'Propietarios',
    dataIndex: 'nombres_de_participes',
    key: 'nombres_de_participes',
    width: 600,
    render: (l = []) => (l?.length ? listToString(l.map((e) => e.trim())) : 'Sin propietarios'),
  },
  {
    titleText: 'Clave Catastral',
    dataIndex: 'clave_catastral_estandar',
    key: 'clave_catastral_estandar',
    width: 200,
  },
  {
    titleText: 'Cuenta Catastral',
    dataIndex: 'clave_catastral_municipal',
    key: 'clave_catastral_municipal',
    width: 200,
  },
  {
    titleText: 'Dirección',
    dataIndex: 'direccion',
    key: 'direccion',
    width: 500,
    render: (direccion, { direccion_index }) => addressToString(direccion || direccion_index),
  },
];

export default columnsPrediosOaxaca;
